(function () {
    var modal = document.getElementById('subscribe-modal');
    if (!modal) return;

    function close() {
        modal.hidden = true;
        document.body.classList.remove('subscribe-open');
    }

    function open() {
        modal.hidden = false;
        document.body.classList.add('subscribe-open');
        var input = modal.querySelector('input[type="email"]');
        if (input) input.focus();
    }

    document.querySelectorAll('.subscribe-trigger').forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            open();
        });
    });

    modal.querySelectorAll('[data-subscribe-close]').forEach(function (el) {
        el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
    });
})();
